import * as React from "react";
import { Grid, Typography } from "components/controls/widget";
import { hasFlag, formatDate } from "components/state/types";
import { MemberApplication, MemberApplicationFormState } from "../entity";
import { getAddress } from "./address";

interface Props {
    application: MemberApplication;
}

const View = ({ application }: Props) => {

    const { surname, name, title, email, birthDate, mobilePhone, homeAddress, postAddress } = application.legalRepresentative;
    const celeJmeno = (title ? title + ' ' : '') + name + ' ' + surname;
    const showHomeAddress = !hasFlag(application.formFlags, MemberApplicationFormState.LegalRepHomeAddressIsSameAsMember);
    const showPostAddress = !hasFlag(application.formFlags, MemberApplicationFormState.LegalRepPostAddressIsSameAsHome);

    return <Grid container>
        <Grid item sm={12}>
            <Typography variant="h6">{"Zákonný zástupce: " + celeJmeno}</Typography>
        </Grid>

        {showHomeAddress && <Grid item sm={12}>
            <Typography variant="subtitle1">{'Adresa bydliště: ' + getAddress(homeAddress)}</Typography>
        </Grid>}

        {showPostAddress && <Grid item sm={12}>
            <Typography variant="subtitle1">{'Korespondenční adresa: ' + getAddress(postAddress)}</Typography>
        </Grid>}

        <Grid item sm={12}>
            <Typography variant="subtitle1">{'Email: ' + email}</Typography>
        </Grid>

        <Grid item sm={12}>
            <Typography variant="subtitle1">{'Telefon: ' + mobilePhone}</Typography>
        </Grid>

        <Grid item sm={12}>
            <Typography variant="subtitle1">{'Datum narození: ' + formatDate(birthDate)}</Typography>
        </Grid>

    </Grid >
}

export {
    View as LegalRepresentativeView,
}